<div class="container-fluid">
  <div class="card">
    <div class="card-header row">
      <form [formGroup]="formFilter" style="width: 100%">
        <div class="media-space-between">
          <h4>{{ "inseights.title" | translate }}</h4>
          <div class="media-space-between">
            <app-date-range-picker
              [form]="formFilter | asFormGroup"
              inputFormControlName="date"
            ></app-date-range-picker>
            <app-search-field
              class="mx-2"
              [form]="formFilter | asFormGroup"
              [filterOptions]="filterAds"
              [placeholder]="'placeholder.searchByCampaignTitle' | translate"
              inputFormControlName="title"
              (emitSelectedOptions)="resultOptionSelected($event)"
            ></app-search-field>
            <app-refresh-button
              [state]="fetchingCampaignsState"
              [date]="cachedAt"
              (buttonClick)="refreshCampaigns(true)"
              style="margin-right: 8px"
            >
            </app-refresh-button>
            <ul
              ngbNav
              #navDisplay="ngbNav"
              [activeId]="1"
              class="nav-border-primary d-flex justify-content-center"
              style="justify-content: right; display: contents"
            >
              <li [ngbNavItem]="1" [destroyOnHide]="true">
                <a ngbNavLink type="button" style="padding: 4px 10px">
                  <img
                    src="assets/identity/table.svg"
                    alt="table"
                    width="20px"
                  />
                </a>
                <ng-template ngbNavContent>
                  <div class="table-responsive data-table">
                    <table class="table table-striped table-border-vertical">
                      <thead>
                        <tr>
                          <ng-container *ngFor="let column of columns">
                            <th
                              sortable
                              [class]="{ sortable: column.sorter }"
                              sortable="{{ column.key }}"
                              (sort)="column.sorter ? onSort($event) : null"
                            >
                              {{ column.label | translate }}
                            </th>
                          </ng-container>
                          <th>{{ "dashboard.options" | translate }}</th>
                        </tr>
                      </thead>
                      <tbody *ngIf="!(loadingAds$ | async)">
                        <ng-container>
                          <tr
                            *ngFor="
                              let adCompaign of resultAdvertisingCompainFilter;
                              let j = index
                            "
                          >
                            <td>
                              <a
                                type="button"
                                [routerLink]="[
                                  '/',
                                  'dashboard',
                                  'advertiser',
                                  'insights',
                                  'statistics',
                                  adCompaign.advertisingCampaignHashedId
                                ]"
                                style="color: black"
                              >
                                <td>
                                  {{ adCompaign.title }}
                                </td>
                              </a>
                            </td>
                            <td class="img-content-box">
                              <i class="icon-eye"></i>
                              {{ adCompaign.views }}
                            </td>
                            <td>
                              {{
                                objectiveTypeEnumMapping[
                                  adCompaign.objectiveName
                                ] | translate
                              }}
                            </td>
                            <td width="20%">
                              <app-column-location-partners
                                [j]="j"
                                [locationPartners]="adCompaign.locationPartners"
                              ></app-column-location-partners>
                            </td>
                            <td>
                              {{ adCompaign.startingDate | localizedDate }}
                            </td>
                            <td>
                              {{ adCompaign.endingDate | localizedDate }}
                            </td>
                            <td>
                              <span
                                [ngClass]="
                                  'badge ' +
                                  badgeService.getBadgeForAdvertisingCampaingStatus(
                                    adCompaign.status
                                  )
                                "
                              >
                                {{
                                  "enumMapping.campaigns.status." +
                                    adCompaign.status | translate
                                }}
                              </span>
                            </td>
                            <td>
                              <app-drop-zone-options
                                [options]="getOptions(adCompaign)"
                                (optionSelected)="
                                  saveAction($event, adCompaign)
                                "
                              ></app-drop-zone-options>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                    <div *ngIf="loadingAds$ | async">
                      <ng-container style="float: right" class="flex">
                        <div class="loader-box">
                          <div class="loader-34"></div>
                        </div>
                        <h6
                          class="col align-self-center f-w-600"
                          style="text-align: center"
                        >
                          {{ "fetching" | translate }}
                        </h6>
                      </ng-container>
                    </div>
                    <div
                      *ngIf="count == 0 && !(loadingAds$ | async)"
                      class="d-flex justify-content-center m-t-20"
                    >
                      {{ "noData" | translate }}
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="2" [destroyOnHide]="true">
                <a ngbNavLink type="button" style="padding: 4px 10px">
                  <img src="assets/identity/card.svg" alt="card" width="20px" />
                </a>
                <ng-template ngbNavContent>
                  <app-card-insights
                    [count]="count"
                    [loading]="loadingAds$ | async"
                    [ad]="resultAdvertisingCompainFilter"
                  ></app-card-insights>
                </ng-template>
              </li>
            </ul>
          </div>
        </div>
      </form>
      <div style="display: flex; justify-content: end">
        <button
          class="btn btn-primary m-r-5 m-t-10"
          type="button"
          (click)="removeFilter()"
        >
          <i class="fa fa-repeat me-2"></i>
          {{ "buttons.removeFilter" | translate }}
        </button>
      </div>
      <div class="m-t-10">
        <div [ngbNavOutlet]="navDisplay" class="mt-2"></div>
        <!--all advertising compaign-->
        <div class="table-responsive data-table">
          <app-pager
            [count]="(resultFilterAdvertisingCompaign$ | async)?.count ?? 0"
            [pageSize]="pageSize"
            [pageNumber]="pageNumber"
            (emitChangePage)="changePage($event)"
            (emitChangePageSize)="itemsPerPageChange($event)"
          ></app-pager>
        </div>
      </div>
    </div>
  </div>
</div>
